import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import DownloadExcel from "../../../Extra/DownloadExcel";
import SpeedTable from "./SpeedTable";
const tables = ["hor", "trains", "trains_total"];
const tableHeadNew = [
  "Section",
  "Running TIme",
  "Speed",
  "No. of Train Run",
  "No. of Train Run (till date)",
  "Avg(till date)",
];
const sectionOrder = [
  "ET-JBP",
  "JBP-STA",
  "STA-MKP",
  "BINA-KTE",
  "KTE-SGRL",
  "STA-REWA",
  "REWA-SGRL",
  "JKE-JQSG",
];

const SpeedMaster = ({ date }) => {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(null);
  const tableRef = useRef();
  const urlCrisPrefix = process.env.REACT_APP_URL_PREFIX_CRIS;

  const fetchApi = async (url) => {
    setLoading(true);
    try {
      const response = await axios.get(url);

      setData(response.data.data);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const speedavg = ["SECTION", "RT UP", "RT DN", "SPEED UP", "SPEED DN"];
  const CumSpeed = ["SECTION", "TOTAL UP", "AVG", "TOTAL DN", "AVG"];

  const speedavgDes = ["sctn", "hor_up", "hor_dn", "speed_up", "speed_dn"];
  const trainCountDes = [
    "sctn",
    "rakecont_up",
    "rakecont_dn",
    "speed_up",
    "speed_dn",
  ];
  const cumSpeedDes = [
    "sctn",
    "cumulative_speed_up",
    "average_speed_up",
    "cumulative_speed_dn",
    "average_speed_dn",
  ];

  useEffect(() => {
    fetchApi(`${urlCrisPrefix}get_wc135_speed_data?date=${date}`);
  }, [date]);
  // ///////////////////sorting

  return (
    <div ref={tableRef}>
      <SpeedTable
        data={data}
        head={speedavg}
        heading={"SPEED AVG"}
        des={speedavgDes}
      />
      <SpeedTable
        data={data}
        head={speedavg}
        heading={"NO. OF TRAIN RUN"}
        des={trainCountDes}
      />
      <SpeedTable
        data={data}
        head={CumSpeed}
        heading={"CUMMULATIVE SPEED"}
        des={cumSpeedDes}
      />
      <div className="m-1">
        <DownloadExcel
          tableRef={tableRef}
          fileName={`CHC SPEED REPORT ${date}`}
        />
      </div>
    </div>
  );
};
export default SpeedMaster;
